module.exports = __webpack_public_path__ + "img/pamphlet_thumb03.2e120eb7.png";